export const ACCOUNT_BALANCE_PLACEHOLDER_VALUES = [
  228000, 254000, 280000, 306000, 332000, 353000, 353000, 353000, 353000,
  332000, 306000, 280000, 254000, 228000, 202000, 176000, 150000, 124000, 98000,
  72000, 51000, 51000, 51000, 72000, 98000, 124000, 150000, 176000, 202000,
]
